// eslint-disable-next-line no-unused-vars
import React, { useState, useContext } from 'react'
/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import queryString from 'query-string'
import { AuthContext } from '../contexts/auth'
import IntegrationApiClient from '../api/integration'
import SlackLoader from './SlackLoader'

const loaderWrapperCss = css`
  display: flex;
  align-items: center;
  margin: 20px 0;
`

const Connected = () => {
  const auth = useContext(AuthContext)
  const [error, setError] = useState(null)

  const integrationApi = new IntegrationApiClient()
  const queryParams = queryString.parse(window.location.search)

  const install = async code => {
    window.onunload = refreshParent

    function refreshParent() {
      window.opener.location.reload()
    }

    try {
      await integrationApi.installSlack(code, auth.firebaseToken)
      window.close()
    } catch (err) {
      setError(
        'An error occured during installation. Please contact the owner at info@sikoraworks.com.'
      )
      console.error(err)
    }
  }

  switch (queryParams.state) {
    case 'install_slack':
      install(queryParams.code)
      break

    default:
  }

  return (
    <main
      css={css`
        display: flex;
        height: 100vh;
        width: 100%;
        align-items: center;
        justify-content: center;
      `}
    >
      <div css={loaderWrapperCss}>
        {error ? (
          <span>{error}</span>
        ) : (
          <>
            <SlackLoader />
            <span>Connecting with Slack...</span>
          </>
        )}
      </div>
    </main>
  )
}

export default Connected
